export default __webpack_public_path__ + "static/97auto_logo_header-57eec9159101ffc35cc89b30f8178af4.jpg";